<script lang="ts">
  import { themeStore } from '../stores/theme.svelte';

  const { theme } = $derived(themeStore);
</script>

<button
  on:click={() => themeStore.toggle()}
  class="relative inline-flex items-center justify-center w-10 h-10 rounded-lg
         text-gray-700 dark:text-gray-200
         hover:bg-gray-100 dark:hover:bg-gray-800
         focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400
         transition-colors duration-200"
  aria-label="Toggle theme"
  title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
>
  {#if theme === 'light'}
    <!-- Sun Icon -->
    <svg
      class="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  {:else}
    <!-- Moon Icon -->
    <svg
      class="w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      />
    </svg>
  {/if}
</button>
